import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import CustomerApp from "@/pages/CustomerApp";
import AdminPanel from "@/pages/AdminPanel";
import EmployeeCheckin from "@/pages/EmployeeCheckin";
import CoordinateTool from "@/pages/CoordinateTool";
import CajaPage from "@/pages/CajaPage";

function App() {
  return (
    <div className="App min-h-screen bg-cream">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CustomerApp />} />
          <Route path="/checkin" element={<EmployeeCheckin />} />
          <Route path="/admin/*" element={<AdminPanel />} />
          <Route path="/caja" element={<CajaPage />} />
          <Route path="/coordinates" element={<CoordinateTool />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
